import type { Email } from '../ContactTypes';
import type { ContactItemPropTypes } from './ContactSelectService';

export function convertEmailsToSelectItems(emails: Email[]): ContactItemPropTypes[] {
    return emails.map((email) => ({
        label: email.address,
        value: email.id,
        isInvalid: email.isInvalid,
    }));
}

export function getSelectEmails(
    cdmEmails: Email[],
    selectEmailValue?: string,
    addValueToItemsIfNotIncluded?: boolean,
): Email[] {
    if (
        !addValueToItemsIfNotIncluded ||
        !selectEmailValue ||
        cdmEmails.some(
            (email) => email.address === selectEmailValue || email.id === selectEmailValue,
        )
    ) {
        return cdmEmails;
    }

    return [...cdmEmails, { id: selectEmailValue, address: selectEmailValue }];
}
